import request from '../../util/SuperagentUtils';
import { bookingTransactionRequests } from '../../requests/api-endpoints';
import type { Response } from 'superagent';

export const getInvoicesInPayout = (payoutCorrelationId: string): Promise<Response> => {
  return request.get(`${bookingTransactionRequests.getByCorrelationId}?correlationId=${payoutCorrelationId}`);
}
